import React, {Fragment} from 'react';
import ContentLoader from "react-content-loader"
import {Link} from 'react-router-dom';
import Avatar from '../../Avatar';
import Icon from '../../Icon';
import Alert from '../../Alert';
import {Button} from "../../Button";
import Modal from "../../Modal";
import createLink from "../../../../libs/createLink";
import {isNoFollowProfil} from "../../../../libs/helper";

class FriendRequest extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            buttonClick: false,
            toggleRequest: false,
            toggleAlertIgnore: false,
        }
    }

    render() {
        let relLinkProfil = {};
        if(this.props.userFriendsRequestInitialized){
            relLinkProfil = isNoFollowProfil(this.props.author) ? { rel: "nofollow" } : {};
        }
        return (
            <Fragment>
                {!this.props.userFriendsRequestInitialized || this.props.author === null ? (
                    <ContentLoader
                        ariaLabel={false}
                        height={60}
                        width={260}
                        speed={2}
                        primaryColor="#f3f3f3"
                        secondaryColor="#ecebeb"
                    >
                        <rect x="72" y="17" rx="4" ry="4" width="117" height="6.4"/>
                        <rect x="72" y="37" rx="3" ry="3" width="85" height="6.4"/>
                        <circle cx="29.4" cy="29.81" r="26.4"/>
                        <rect x="257.78" y="40.61" rx="0" ry="0" width="0" height="0"/>
                        <circle cx="247.8" cy="28.63" r="8.02"/>
                    </ContentLoader>
                ) : (
                    <div className="friends">
                        <Link to={createLink('userProfile', this.props.author)} {...relLinkProfil}>
                            <Avatar avatar={this.props.author.profile.avatar || ""}
                                    gender={this.props.author.profile.gender} alt=""/>
                        </Link>
                        <div className="infos-user-wrapper">
                            <Link to={createLink('userProfile', this.props.author)} {...relLinkProfil}>
                                <div className="username">{this.props.author.username || ""}</div>
                            </Link>
                        </div>
                        <div className="btn-group request">
                            <div className="ignore-friend" onClick={() => this.setState({toggleAlertIgnore: true})}>
                                <Icon
                                    type="close"/></div>
                            <Modal toggle={this.state.toggleAlertIgnore}
                                   handleClose={() => this.setState({toggleAlertIgnore: false})}>
                                <Alert
                                    text="Refuser cette demande d’amitié ?"
                                    handleClose={() => this.setState({toggleAlertIgnore: false})}
                                    handleDelete={() => this.setState({toggleAlertIgnore: false, toggleRequest : false}, () => {
                                        this.props.handleRefuseFriendRequest(this.props._id)
                                    })}
                                />
                            </Modal>
                            {this.props.contents.length >= 1 && (
                                <div className="see-answers" onClick={() => this.setState({toggleRequest: true})}><Icon
                                    type="info"/></div>)}
                            <Modal toggle={this.state.toggleRequest}
                                   handleClose={() => this.setState({toggleRequest: false})}>
                                <div id="checkRequest" className={"modal-container"}>
                                    <div className={"modal-topline"}>
                                        <h3>Réponses aux questions</h3>
                                        <span onClick={() => this.setState({toggleRequest: false})}
                                              className="responsive-hidden"><Icon type="close"/></span>
                                    </div>
                                    <div className={"modal-body"}>
                                        <div className="answers-container">
                                            <div className="answers-container-inner column">
                                                {this.props.contents && this.props.contents.map((item, index) => (
                                                    <div key={index} className="block column">
                                                        <div className="question-container">{item.question}</div>
                                                        <div className="answer-container">{item.answer}</div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"modal-baseline"}>
                                        <Button size={"small"}
                                                btnStyle={"grey"}
                                                onClick={() => this.setState({toggleRequest: false})}
                                                content={"Annuler"} />
                                        <Button size={"small"}
                                                btnStyle={"cancel"}
                                                onClick={() => this.setState({toggleAlertIgnore: true})}
                                                content={"Refuser"} />
                                        <Button size={"small"}
                                                btnStyle={"primary-reverse"}
                                                onClick={() => this.props.handleAcceptFriendRequest(this.props._id)}
                                                content={"Accepter en ami"} />
                                    </div>
                                </div>
                            </Modal>
                            <div className="add-friend"
                                 onClick={() => this.props.handleAcceptFriendRequest(this.props._id)}><Icon
                                type="check"/></div>
                        </div>
                    </div>
                )}
            </Fragment>
        )
    }
}

FriendRequest.defaultProps = {
    _id: 0,
    slug: '',
    username: '',
    profile: {avatar: "", gender: "3"},
};

export default FriendRequest;
